import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const InfoBanner = ({ icon, iconComponent, body, linkUrl, backgroundColor, classNames, style }) => {
  return (
    <div style={style} className={classnames('InfoBanner', backgroundColor, classNames)}>
      { icon &&
        <div className="margin-lg-right icon-container">
          <img className="icon" src={`https://assets.peerspace.com/${icon}.svg?v=rb`} alt={icon} />
        </div>
      }
      { iconComponent &&
        <div className="margin-md-right icon-container">
          {iconComponent}
        </div>
      }
      <div className="text-left" style={{ width: '100%' }}>
        {body}
      </div>
    </div>
  );
};

InfoBanner.propTypes = {
  body: PropTypes.element,
  icon: PropTypes.string,
  backgroundColor: PropTypes.string,
  classNames: PropTypes.string
};

export default InfoBanner;
